import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export function useRtl() {
  const { locale, availableLocales } = useI18n();
  const locales = new Set(availableLocales);
  const isRtl = computed(() => locales.has(locale.value) && locale.value === 'ar');
  return { isRtl };
}
